import { capitalize } from "reusable/utils/string-utils"
import { messageError } from "./message-error"
import { messageInfo } from "./message-info"
import { executeLoading } from "./execute-loading"
import { messageActions } from "./message-actions"
import { apiClientSilent } from "api/trpc/trpc-client"
import { UserOnboardingDefaults } from "variables/variables"

export default async function createGapOrgPopup({ firstName, lastName, email }: { firstName?: string, lastName?: string, email: string }) {
   return messageActions({
      children: "The Gap organisation hasn't been created yet",
      title: "Configuration Required",
      primary: {
         name: 'Create Data',
         callback: async () => {
            await executeLoading("Creating initial data...", async () => {
               try {
                  await apiClientSilent.user.createGapUser.mutate(
                     {
                        firstName: firstName ?? capitalize(email.split('@')[0]),
                        lastName: lastName ?? capitalize(email.split('@')[0]),
                        id: "",
                        email,
                        // Temp, this function should never be called and will be removed 
                        onboarding: UserOnboardingDefaults,
                     })

                  await messageInfo("Initial data created successfully!")
               } catch (error) {
                  await messageError(`${error}`, 'Error creating initial data')
               }
               window.location.reload();
            })
         }
      }
   })
}
